export function setToken(key, val) {
  localStorage.setItem(key, val);
}
export function getToken(key) {
  return localStorage.getItem(key);
}
export function removeToken(key) {
  localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js